import { render } from 'react-dom'
import { App } from './App.jsx'

render(<App />, document.getElementById('root'))
